import { render, staticRenderFns } from "./FormEventTypeLocale.vue?vue&type=template&id=6f8e1f88&scoped=true&"
import script from "./FormEventTypeLocale.vue?vue&type=script&lang=js&"
export * from "./FormEventTypeLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8e1f88",
  null
  
)

export default component.exports